import { type AbtestLimitErrors } from '@marpla/core/enum';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { type Draft } from 'immer';

// export enum AbModalError {
// 	low_balance_error = 'low_balance_error',
// 	auto_top_up_error = 'auto_top_up_error',
// }

interface ModalsState {
  isAdsOpen: boolean;
  isSalesOpen: boolean;
  isAbOpen: boolean;
  isAbSettingsOpen: boolean;
  isTopUpOpen: boolean;
  abError: AbtestLimitErrors | null;
}

const initialState: ModalsState = {
  isAdsOpen: false,
  isSalesOpen: false,
  isAbOpen: false,
  isAbSettingsOpen: false,
  isTopUpOpen: false,
  abError: null,
};

const modalsTariffSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openAdsModal(state: Draft<ModalsState>) {
      state.isAdsOpen = true;
    },
    closeAdsModal(state: Draft<ModalsState>) {
      state.isAdsOpen = false;
    },
    openSalesModal(state: Draft<ModalsState>) {
      state.isSalesOpen = true;
    },
    closeSalesModal(state: Draft<ModalsState>) {
      state.isSalesOpen = false;
    },
    openAbSettingsModal(state: Draft<ModalsState>) {
      state.isAbSettingsOpen = true;
    },
    closeAbSettingsModal(state: Draft<ModalsState>) {
      state.isAbSettingsOpen = false;
    },

    openAbModal: {
      reducer(
        state: Draft<ModalsState>,
        action: PayloadAction<{ errorType: AbtestLimitErrors | null } | undefined>,
      ) {
        state.isAbOpen = true;
        state.abError = action?.payload?.errorType || null;
      },
      prepare: (payload?: { errorType: AbtestLimitErrors | null }) => ({ payload }),
    },
    closeAbModal(state: Draft<ModalsState>) {
      state.isAbOpen = false;
      state.abError = null;
    },

    openTopUpModal(state: Draft<ModalsState>) {
      state.isTopUpOpen = true;
    },
    closeTopUpModal(state: Draft<ModalsState>) {
      state.isTopUpOpen = false;
    },

    setModalState(state: Draft<ModalsState>, action: PayloadAction<Partial<ModalsState>>) {
      Object.assign(state, action.payload);
    },
  },
});

export const {
  openAdsModal,
  closeAdsModal,
  openSalesModal,
  closeSalesModal,
  openAbSettingsModal,
  closeAbSettingsModal,
  openAbModal,
  closeAbModal,
  openTopUpModal,
  closeTopUpModal,
  setModalState,
} = modalsTariffSlice.actions;

export const selectAbModalError = (s: { modals: ModalsState }): ModalsState['abError'] =>
  s.modals.abError;

export default modalsTariffSlice.reducer;
